import useStyles from './styles';
import { Box } from '@mui/system';
import { Button } from '@mui/material';
import ReactJson from 'react-json-view';
import { toast } from 'react-toastify';
import { isSplitDocValid } from '../../utilities/splitDocConfigChecks';
import { SPLIT_DOC_EDIT_MODES, SPLIT_DOC_PARAMETERS } from '../../core/constants';
import {
	createSplitDocForSite,
	updateSplitDocForSite,
	syncSplitDocForSite
} from '../../api/splitDoc';

const { SITE_ID, SITE_DOMAIN } = SPLIT_DOC_PARAMETERS;

const FinalOverview = ({ getSplitDocWithEncodedScripts, splitDocEditMode, previousSplitDoc }) => {
	const classes = useStyles();

	const finalOverviewObject = getSplitDocWithEncodedScripts();

	const handleButtonClicked = async () => {
		try {
			isSplitDocValid(finalOverviewObject);
			const dataObject = {
				data: finalOverviewObject,
				previousCouchBaseConfig: previousSplitDoc.current,
				mode: splitDocEditMode,
				siteId: finalOverviewObject.siteId,
				siteDomain: finalOverviewObject.siteDomain
			};

			if (splitDocEditMode === SPLIT_DOC_EDIT_MODES.CREATE) {
				await createSplitDocForSite(dataObject);
				toast.success('Script Split Doc successfully created!', {
					position: toast.POSITION.BOTTOM_RIGHT
				});
			}
			if (splitDocEditMode === SPLIT_DOC_EDIT_MODES.UPDATE) {
				await updateSplitDocForSite(dataObject);
				toast.success('Script Split Doc successfully Updated', {
					position: toast.POSITION.BOTTOM_RIGHT
				});
			}
			//previousSplitDoc must be made the new one since now the new version is updated in couchbase
			previousSplitDoc.current = finalOverviewObject;
		} catch (err) {
			const errorMessage = err?.response?.data?.data?.message || err.message;
			toast.error(errorMessage, {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		}
	};

	const handleSyncButtonClicked = async () => {
		try {
			const dataObject = {
				siteId: finalOverviewObject[SITE_ID],
				siteDomain: finalOverviewObject[SITE_DOMAIN],
				previousCouchBaseConfig: previousSplitDoc,
				data: previousSplitDoc,
				mode: SPLIT_DOC_EDIT_MODES.SYNC
			};
			const data = await syncSplitDocForSite(dataObject);
			toast.success(data?.data?.message || 'Sync success', {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		} catch (err) {
			const errMessage = err?.response?.data?.data?.message || err.message;
			toast.error(errMessage || 'Some Error Occured', {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		}
	};

	return (
		<Box
			style={{
				position: 'absolute',
				bottom: '6rem',
				right: '50%',
				transform: 'translate(50%,50%)',
				width: '40rem',
				display: 'flex',
				justifyContent: 'space-between'
			}}
		>
			<Button variant="contained" style={{ margin: '0 auto' }} onClick={handleButtonClicked}>
				{splitDocEditMode && splitDocEditMode.replaceAll('_', ' ')}
			</Button>
			<Button variant="contained" style={{ margin: '0 auto' }} onClick={handleSyncButtonClicked}>
				Sync Split Doc
			</Button>

			<Box className={classes.finalOverview}>
				<ReactJson
					enableClipboard={true}
					displayDataTypes={false}
					src={finalOverviewObject}
					name={null}
				/>
			</Box>
		</Box>
	);
};

export default FinalOverview;
